/*!
 * Copyright © 2025 Actavivo
 */
import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";
import { AVEntity } from "./AVEntity";

export class Pay {
	static _payApi = "/api/Pay";

	public static async options(token: string): Promise<AV.ICollectOptions> {
		return await Server.get(this._payApi + "/Options", { token: token }, true);
	}
	public static async hInit(payParam: AV.IPayParam): Promise<AV.IPayInitResp> {
		//var param: AV.IPayParam = { source: source, target: target };
		return await Server.post(this._payApi + "/HInit", payParam, true);
	}
	//Use this is logged in
	public static async hInitAuth(payParam: AV.IPayParam): Promise<AV.IPayInitResp> {
		//var param: AV.IPayParam = { source: source, target: target };
		return await Server.post(this._payApi + "/HInitAuth", payParam);
	}
	public static async hResult(param: AV.IPayResutParam): Promise<AV.IPayResultResp> {
		var param: AV.IPayResutParam = param;
		return await Server.post(this._payApi + "/HResult", param, true);
	}
	public static async myActivity(): Promise<AV.ICollectLog[]> {
		//var param: AV.IPayParam = { source: source, target: target };
		return await Server.post(this._payApi + "/MyActivity");
	}

    public static async createPayment(options: AV.ICollectOptions): Promise<string> {
        try {
            const response = await Server.post<string>(
                `${this._payApi}/CreatePayment`, 
                options
            );
            return response;
        } catch (error) {
            console.error('Payment service error:', error);
            throw error;
        }
    }
}
